import $ from "../libs/jquery-3.3.1.min.js"
import {BaseGame} from "/js/app/base/BaseGame";
// import {AudioPlaylist} from '/js/app/base/AudioPlaylist.js'
// import {gsap} from "../libs/gsap/all.js"
// import {Howl, Howler} from 'howler';
// import nunjucks from "/js/libs/nunjucks.js"

// Constructor
export class VideotronTV extends BaseGame {

  constructor() {

    // Super constructor
    super("data/gustav_videotron_tv.json"); // unneeded but let's keep it if we need to later on

    // Wait for all
    Promise.all([
      this.loadSettings(),
      this.loadData()
    ]).then(() => {
      // Preload audio files
      return this.preloadAudio();
    }).then(() => {
      // Ini nunjucks
      return this.initNunjucks();
    }).then(() => {
      // Replace strings {{ }}
      return this.renderNunjucks();
    }).then(() => {
      // Real game init
      return this.initGame();
    }).catch((error) => {
      console.error("error", error)
      $("#main").append("<div id='error'>Error: " + error.message + "</div>")
    });
  }

  // To be overridden in child games
  initGame() {

    // Nothing much to do

    // super.initGame(); // We don't need the BaseGame in this case so let's skip it and handle things just here
  };

  reset(screenId) {

    // There is no real need to reset the app here as it's a single screen app in this case


    // if (this.currentTimeline) {
    //   this.currentTimeline.kill();
    //   this.currentTimeline = null;
    // }
    //
    // let resetCallback = () => {
    //   // TODO Add things to append after reset here, if required
    //
    //
    // }
    //
    // // TODO Reset other things here
    // this.animateScreen1();

    // Super
    if (super.reset(screenId, resetCallback) == false) {
      return false;
    }

  }

}
